import React, { useState, useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import {
  MDBPagination,
  MDBPaginationItem,
  MDBPaginationLink
} from 'mdb-react-ui-kit';
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { get } from "../../Services/RestAPIService";
import { Link, useNavigate } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import Dummy from "../../assets/images/No_Image_Available.jpg"
import OrganizationChart from "components/Modal Org/OrganizationChart";

const DatatableTables = ({ t }) => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    columns: [
      {
        label: t("ID"),
        field: "id",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Name"),
        field: "name",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Status"),
        field: "is_active",
        sort: "asc",
        width: 270,
      },
      {
        label: t("Image"),
        field: "image",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Subcategory"),
        field: "subCategory",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Edit"),
        field: "edit",
        sort: "asc",
        width: 100,
      },
      {
        label: t("View Org Chart"),
        field: "viewOrgChart",
        sort: "asc",
        width: 150,
      },
    ],
    rows: []
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isOrgChartOpen, setIsOrgChartOpen] = useState(false);
  const [selectedOrgId, setSelectedOrgId] = useState(null);

  const getUsersData = async (page) => {
    try {
      const usersData = await get(`category/categories/?page=${page}&page_size=5&parent_id_isnull=true`);
      setTotalPages(Math.ceil(usersData.count / 5));

      const modifiedRows = usersData.results.map(row => ({
        ...row,
      }));

      setData(prevState => ({
        ...prevState,
        rows: modifiedRows
      }));
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  useEffect(() => {
    getUsersData(currentPage);
  }, [currentPage]);

  const handleCheckboxChange = (id) => {
    const updatedSelectedRows = [...selectedRows];
    const index = updatedSelectedRows.indexOf(id);
    if (index === -1) {
      updatedSelectedRows.push(id);
    } else {
      updatedSelectedRows.splice(index, 1);
    }
    setSelectedRows(updatedSelectedRows);
  };

  const handleButtonClick = () => {
    const selectedIds = selectedRows;
    console.log("Selected IDs:", selectedIds);
  };

  const handleTableChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleEdit = (id) => {
    navigate(`/category/edit/${id}`);
    console.log("Edit button clicked for user with ID:", id);
  };

  const handleExercises = (id) => {
    navigate(`/category/sub-category/${id}`);
    console.log("Edit button clicked for user with ID:", id);
  };

  const handleViewOrgChart = (id) => {
    setSelectedOrgId(id);
    setIsOrgChartOpen(true);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle={t("Home")} title={t("Data")} breadcrumbItem={t("Pain Area's")} />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-4">

                  <CardTitle className="h4">{t("Pain Area's of body.")}</CardTitle>
                  <Button color="primary" onClick={()=>{navigate(`/category/create-category`)}
                  }><i className="typcn typcn-plus"></i> {t("Create New Pain Area")}</Button>
                  </div>

                  <MDBDataTable
                    responsive
                    striped
                    bordered
                    paging={false}
                    data={{
                      columns: data.columns,
                      rows: data.rows.map(row => ({
                        ...row,
                        select: <input type="checkbox" checked={selectedRows.includes(row.id)} onChange={() => handleCheckboxChange(row.id)} />,
                        image: <img src={row.image || Dummy} alt="User" width="50" height="50" />,
                        edit: <Button color="secondary" onClick={() => handleEdit(row.id)}>{t("Edit")}</Button>,
                        subCategory: <Button color="primary" onClick={() => handleExercises(row.id)}>{t("Pain Area Body Parts")}</Button>,
                        is_active: row.is_active ? t('True') : t('False'),
                        viewOrgChart: <Button color="info" onClick={() => handleViewOrgChart(row.id)}>{t("View Org Chart")}</Button>,
                      }))
                    }}
                    className="custom-cursor-pointer"
                  />

                  {/* <Button color="primary" onClick={()=>{navigate(`/category/create-category`)}
                  }><i className="typcn typcn-plus"></i> {t("Create New Pain Area")}</Button> */}

                  <MDBPagination className='mt-3'>
                    <MDBPaginationItem disabled={currentPage === 1}>
                      <MDBPaginationLink onClick={() => handleTableChange(currentPage - 1)} tabIndex="-1" aria-disabled={currentPage === 1}>{t("Previous")}</MDBPaginationLink>
                    </MDBPaginationItem>
                    {[...Array(totalPages).keys()].map(page => (
                      <MDBPaginationItem key={page + 1} active={currentPage === page + 1}>
                        <MDBPaginationLink onClick={() => handleTableChange(page + 1)}>
                          {page + 1}
                        </MDBPaginationLink>
                      </MDBPaginationItem>
                    ))}
                    <MDBPaginationItem disabled={currentPage === totalPages}>
                      <MDBPaginationLink onClick={() => handleTableChange(currentPage + 1)}>{t("Next")}</MDBPaginationLink>
                    </MDBPaginationItem>
                  </MDBPagination>
                  
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <OrganizationChart isOpen={isOrgChartOpen} onClose={() => setIsOrgChartOpen(false)} orgId={selectedOrgId} />
    </React.Fragment>
  );
};

export default withTranslation()(DatatableTables);

